import React, { Fragment } from "react";
import {
  Grid,
  Button,
  Checkbox,
  Paper,
  FormControl,
  FormGroup,
  FormControlLabel,
  MenuItem,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import NumberFormatCustom from "../../numberFormat";
import InputFormat from "../../../partials/inputForm";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import bankCodeVnPay from "../../../utils/bankCodeVnPay.json";
import PaymentStripe from "./paymentStripe";
import { styles } from "./style";
import {
  ADMIN_URL,
  _checkRequired,
  isJsonString,
} from "../../../utils/setting";

class AddPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      valid: {},
      paymentTypeCard: "",
      payment: {
        amount: "",
        info: "",
      },
    };
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  showMessage(arr = []) {
    const { t } = this.props;
    let valid = {};
    arr.forEach((e) => {
      if (e === "amount") {
        valid.amount = {
          invalid: true,
          message: t("payment_pls_enter_amount"),
        };
      } else if (e === "bankCode") {
        valid.bankCode = {
          invalid: true,
          message: t("payment_pls_enter_bank"),
        };
      } else if (e === "info") {
        valid.info = {
          invalid: true,
          message: t("payment_pls_enter_info"),
        };
      }
    });
    return {
      valid,
      flag: Object.keys(valid).length ? true : false,
    };
  }
  handleDialogClose = () => {
    this.PopUpInterface.handleDialogClose();
  };
  handleDialogOpen = () => {
    this.PopUpInterface.handleDialogOpen();
  };
  handleChange = (event) => {
    let payment = this.state.payment;
    payment[event.target.name] = event.target.value;
    this.setState({ payment });
  };
  handleChangeTypeCard = (e) => {
    let paymentTypeCard = this.state.paymentTypeCard;
    paymentTypeCard = e.target.name;
    this.setState({ paymentTypeCard: paymentTypeCard });
  };
  handleChangeStep = () => {
    let step = this.state.step;
    this.setState({ step: step + 1 });
  };
  handleSubmit = () => {
    const { setting } = this.props;
    const { payment, paymentTypeCard } = this.state;
    // let locale = i18n.language == "vn" ? "vn" : "en";
    let returnUrl = `${ADMIN_URL}/service/payment`;
    let arr = _checkRequired(payment, ["amount", "info"]);
    let check = this.showMessage(arr);
    if (!check.flag) {
      //true
      this.loading.startLoading();
      this.props.createPaymentZaloPay({
        ...payment,
        paymentTypeCard: paymentTypeCard,
        currency: setting.currencyCode,
        returnUrl: returnUrl,
      });
      this.loading.stopLoading();
    } else {
      this.setState({ valid: check.valid });
    }
  };
  render() {
    const { classes, t, setting } = this.props;
    const { payment, valid, paymentTypeCard, step } = this.state;
    if (isJsonString(setting.paymentMethod)) {
      setting.paymentMethod = JSON.parse(setting.paymentMethod);
    }
    return (
      <React.Fragment>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Paper className={classes.root}>
          <Grid container spacing={3}>
            {step == 1 &&
              setting.paymentMethod &&
              setting.paymentMethod.indexOf("vietNamPayment") != -1 && (
                <Grid item xs={4} sm={4}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormGroup>
                      <img
                        src={"/images/creditCard.svg"}
                        className={classes.iconCard}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              paymentTypeCard == "creditCard" ? true : false
                            }
                            name="creditCard"
                            onChange={this.handleChangeTypeCard}
                          />
                        }
                        className={classes.label}
                        label={t("extend_credit_card")}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
              )}
            {step == 1 && setting.paymentMethod.indexOf("stripe") != -1 && (
              <Grid item xs={4} sm={4}>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <FormGroup>
                    <img
                      src={"/images/visaCard.svg"}
                      className={classes.iconCard}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={paymentTypeCard == "visaCard" ? true : false}
                          name="visaCard"
                          onChange={this.handleChangeTypeCard}
                        />
                      }
                      className={classes.label}
                      label={t("extend_international_card")}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            )}
            {step == 2 && (
              <React.Fragment>
                <Grid item xs={6} sm={6}>
                  <InputFormat
                    required
                    label={t("payment_order_amount")}
                    name="amount"
                    value={payment.amount}
                    onChange={this.handleChange}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                  {valid.amount && valid.amount.message ? (
                    <div className={classes.message}>
                      <div
                        className={`${
                          valid.amount && valid.amount.invalid
                            ? "invalid"
                            : "valid"
                        }-feedback text-left d-block`}
                      >
                        {valid.amount ? valid.amount.message : ""}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={6} sm={6}>
                  <InputFormat
                    required
                    label={t("payment_order_info")}
                    name="info"
                    value={payment.info}
                    onChange={this.handleChange}
                  />
                  {valid.info && valid.info.message ? (
                    <div className={classes.message}>
                      <div
                        className={`${
                          valid.info && valid.info.invalid ? "invalid" : "valid"
                        }-feedback text-left d-block`}
                      >
                        {valid.info ? valid.info.message : ""}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </React.Fragment>
            )}
            {/* {step == 2 && paymentTypeCard == "visaCard" && (
              <PaymentStripe onRef={(id) => (this.paymentStripe = id)} />
            )} */}
          </Grid>

          {/*  Button */}
          {step == 1 && (
            <Grid container spacing={12} justify="flex-end">
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => this.handleChangeStep()}
              >
                {t("next")}
              </Button>
            </Grid>
          )}
          {step == 2 && (
            <Grid container spacing={12} justify="flex-end">
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => this.handleSubmit()}
              >
                {t("service_account_add_payment")}
              </Button>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  setting: state.setting.setting,
});

const mapDispatch = (dispatch) => ({
  createPaymentVNPay: dispatch.serviceAccount.createPaymentVNPay,
  createPaymentZaloPay: dispatch.serviceAccount.createPaymentZaloPay,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: true })(AddPayment))
);
